var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasisbrandschutz = function SvgBasisbrandschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.226,
    height: 75.866
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__c",
    x1: 39.638,
    x2: 36.074,
    y1: 62.668,
    y2: 7.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__a",
    x1: 51.271,
    x2: 45.684,
    y1: 49.704,
    y2: 8.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__d",
    x1: 45.891,
    x2: 50.285,
    y1: 52.534,
    y2: 12.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__e",
    x1: 14.616,
    x2: 22.307,
    y1: 40.551,
    y2: 45.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basisbrandschutz_svg__a",
    id: "basisbrandschutz_svg__f",
    x1: 31.864,
    x2: 21.847,
    y1: 54.395,
    y2: 8.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__g",
    x1: 38.615,
    x2: 38.615,
    y1: 51.221,
    y2: 12.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf3012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__h",
    x1: 40.679,
    x2: 61.285,
    y1: 28.922,
    y2: 19.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#f1710f",
    stopOpacity: 0.861
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f69b33",
    stopOpacity: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__b",
    x1: 67.587,
    x2: -3.092,
    y1: 64.442,
    y2: 64.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dba283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basisbrandschutz_svg__b",
    id: "basisbrandschutz_svg__i",
    x1: 0.878,
    x2: 75.348,
    y1: 64.537,
    y2: 64.537
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__j",
    x1: 33.671,
    x2: 42.525,
    y1: 66.927,
    y2: 59.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basisbrandschutz_svg__k",
    x1: 41.467,
    x2: 32.405,
    y1: 63.815,
    y2: 60.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__c)",
    d: "M41.577 0S38.444 12.387 55.99 26.494c15.826 12.725-.359 36.773-17.404 36.335-17.116-.44-27.259-12.54-24.285-31.285 1.163 4.654.905 7.498 6.98 13.186C16.24 34.775 10.422 19.392 41.578 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__a)",
    d: "m61.241 35.615-.004-.004c-1.144 11.384-9.05 16.651-12.836 16.392-7.384-.508-1.359-8.052-3.618-15.515-.928-3.054-3.142-5.79-5.194-8.171a18.83 18.83 0 0 1-4.198-8.336q-.14-.658-.262-1.32c-.002-2.913 3.86-14.574 5.544-17.246a19.9 19.9 0 0 0 .844 6.741c1.316 4.534 4.815 11.492 14.023 18.895a16.05 16.05 0 0 1 5.701 8.564"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__d)",
    d: "m61.241 35.615-.004-.004c-1.144 11.384-9.05 16.651-12.836 16.392-7.384-.508-1.359-8.052-3.618-15.515-.928-3.054-3.142-5.79-5.194-8.171a20.1 20.1 0 0 1-3.765-7.631c-.821-3.597.743-8.493.743-8.493a30.6 30.6 0 0 0-1.438 6.468 15.3 15.3 0 0 0 2.105 8.05c.188.311.386.617.586.922 1.802 2.715 3.585 5.313 4.098 8.607a14 14 0 0 1-1.016 7.615 22.9 22.9 0 0 1-5.082 7.113c-2.4 2.4-4.278 8.705 5.437 11.008a22.47 22.47 0 0 0 10.908-4.765 25.9 25.9 0 0 0 8.442-11.537 17.2 17.2 0 0 0 .634-10.059",
    opacity: 0.99
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__e)",
    d: "M21.38 45.437a.7.7 0 0 1-.588-.185c-4.255-3.984-5.503-6.635-6.239-9.417 0 0 2.16 13.886 10.34 15.892 0 0-2.986-3.855-3.512-6.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__f)",
    d: "M35.82 50.968a22.9 22.9 0 0 0 5.082-7.113 15 15 0 0 0 .702-2.056 22.6 22.6 0 0 0-.414-5.255c-.487-3.144-2.632-5.542-4.286-8.126a17 17 0 0 1-3.028-8.858c-.038-3.864 1.961-7.345 2.203-11.146a4.95 4.95 0 0 0-.521-2.717.8.8 0 0 0-.302-.341c-.436-.222-1.476.885-1.801 1.138q-1.041.81-2.053 1.657a62 62 0 0 0-3.672 3.322 42 42 0 0 0-5.592 6.664 25.1 25.1 0 0 0-3.588 7.934c-1.676 6.96.628 12.926 3.369 18.336a.715.715 0 0 1-1.127.845c-4.255-3.984-5.503-6.635-6.239-9.417-.406 7.301 1.368 13.514 5.214 18.137 4.258 5.119 10.772 7.934 18.837 8.142q.221.005.442.005a18 18 0 0 0 2.204-.145c-9.707-2.304-7.83-8.606-5.43-11.006"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__g)",
    d: "M36.55 12.257c-.346 1.731-.81 3.44-1.02 5.164a14.8 14.8 0 0 0 .363 5.133c.677 3.45 3.303 5.993 4.872 9.23a14.1 14.1 0 0 1 1.55 5.144 13.6 13.6 0 0 1-.582 5.327 20.4 20.4 0 0 1-5.913 8.713 21.9 21.9 0 0 0 5.442-8.85 14 14 0 0 0 .435-5.13 13.5 13.5 0 0 0-1.535-4.897c-.79-1.545-1.803-2.971-2.758-4.462a14.7 14.7 0 0 1-2.137-4.926 12.75 12.75 0 0 1-.217-5.353 34 34 0 0 1 1.5-5.093"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__h)",
    d: "m61.241 35.615-.004-.004c-1.144 11.384-9.05 16.651-12.836 16.392-7.384-.508-1.359-8.052-3.618-15.515-.928-3.054-3.142-5.79-5.194-8.171a18.83 18.83 0 0 1-4.198-8.336q-.14-.658-.262-1.32c-.002-2.913 3.86-14.574 5.544-17.246a19.9 19.9 0 0 0 .844 6.741c1.316 4.534 4.815 11.492 14.023 18.895a16.05 16.05 0 0 1 5.701 8.564"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__b)",
    d: "M70.66 75.783a95.7 95.7 0 0 0-65.095 0 1.536 1.536 0 0 1-1.963-1.17L.078 62.036a1.903 1.903 0 0 1 1.024-2.312 108.37 108.37 0 0 1 74.022 0 1.903 1.903 0 0 1 1.024 2.312l-3.524 12.577a1.536 1.536 0 0 1-1.963 1.17"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__i)",
    d: "M71.132 74.848a.6.6 0 0 1-.212-.037 96.47 96.47 0 0 0-65.614 0 .6.6 0 0 1-.212.037.704.704 0 0 1-.657-.55L.913 61.723a.93.93 0 0 1 .045-.63.72.72 0 0 1 .405-.396 107.62 107.62 0 0 1 73.5 0 .72.72 0 0 1 .405.395.93.93 0 0 1 .045.63L71.788 74.3a.704.704 0 0 1-.656.548"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__j)",
    d: "m38.395 56.335 1.643 3.329a.32.32 0 0 0 .237.172l3.673.534a.315.315 0 0 1 .175.537l-2.658 2.59a.32.32 0 0 0-.09.28l.627 3.658a.315.315 0 0 1-.457.332L38.26 66.04a.32.32 0 0 0-.294 0l-3.285 1.727a.315.315 0 0 1-.457-.332l.628-3.658a.32.32 0 0 0-.091-.28l-2.658-2.59a.315.315 0 0 1 .175-.537l3.673-.534a.32.32 0 0 0 .237-.172l1.643-3.329a.315.315 0 0 1 .564 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basisbrandschutz_svg__k)",
    d: "M38.113 56.16a.31.31 0 0 1 .282.175l1.643 3.329a.32.32 0 0 0 .237.172l3.673.534a.315.315 0 0 1 .175.537l-2.658 2.59a.32.32 0 0 0-.09.28l.627 3.658a.314.314 0 0 1-.457.332L38.26 66.04a.32.32 0 0 0-.294 0l-3.285 1.727a.314.314 0 0 1-.457-.332l.628-3.658a.32.32 0 0 0-.091-.28l-2.658-2.59a.315.315 0 0 1 .175-.537l3.673-.534a.32.32 0 0 0 .237-.172l1.643-3.329a.31.31 0 0 1 .282-.175m0-.327a.64.64 0 0 0-.575.358l-1.643 3.328-3.664.528a.641.641 0 0 0-.356 1.094l2.658 2.59-.63 3.648a.64.64 0 0 0 .93.677l3.285-1.728 3.275 1.728a.641.641 0 0 0 .93-.677l-.627-3.658 2.655-2.58a.641.641 0 0 0-.356-1.094l-3.673-.534-1.634-3.322a.64.64 0 0 0-.575-.358",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf8364",
    d: "m34.46 67.752.627-3.659a.32.32 0 0 0-.09-.278l-.153-.15a.3.3 0 0 1 .008.111l-.628 3.659a.31.31 0 0 0 .24.351c0-.012-.007-.022-.005-.034M40.273 59.98a.32.32 0 0 0 .237.173l3.673.534c.01.001.016.009.025.01a.307.307 0 0 0-.26-.327l-3.673-.534a.3.3 0 0 1-.092-.037ZM32.513 60.687l3.673-.534a.32.32 0 0 0 .237-.172l1.643-3.329a.31.31 0 0 1 .417-.139l-.087-.178a.315.315 0 0 0-.565 0l-1.643 3.329a.32.32 0 0 1-.237.172l-3.673.534a.315.315 0 0 0-.175.537l.148.144a.31.31 0 0 1 .262-.364"
  }))));
};
export default SvgBasisbrandschutz;